export default function dateDiff(a, b) {
    return a.getTime() - b;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/date-utils/date-diff.js
// module id = 626
// module chunks = 29